module.exports = __webpack_public_path__ + "img/team_2_index.d219e15f.png";